/****
 * Users Report Page Component
 * In this component we declare all the Users Report page functionlities
 * we Diiplay Users Report data in this compont
 */

import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BlockModal from "../../../Components/BlockModal";
import DialogModal from "../../../Components/DialogModal";
import { AppContainer, ShowTotal } from "../../../Components/Global/Reusable";
import StyledTable from "../../../Components/Table";
import { UpdateRow } from "../../../features/UsersReportSlice";
import { useAuth } from "../../../Hooks/useAuth";
import TableData from "./BodyData";
import Details from "./Details";
import Labels from "./Labels";
import { Toast } from "../../../Components/Toast";
import { TABLES } from "../../../enums/tables";

export default function Index() {
  const [data, setData] = useState(null);
  const [Id, setId] = useState(null);
  const [details, setDetails] = useState(false);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    title: "",
    variation: "",
  });
  const [orderFilter, setOrderFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [modalFilter, setModalFilter] = useState({
    isOpen: false,
    data: null,
    type: null,
  });

  const timerRef = useRef(0);

  /***
   * Declare a method to Open and close Details
   * We are receiving {row.id} parameters
   */
  function toggleToast(isOpen) {
    setIsToastOpen(isOpen);
  }

  function onToastOpen(title, variation) {
    setToastMessage({ title: title, variation: variation });
    toggleToast(false);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(function () {
      toggleToast(true);
    }, 100);
  }

  function OpenDetails(rowId) {
    setDetails(true);
    setId(rowId);
  }

  function CloseDetails() {
    setDetails(false);
  }

  /**
   * Declare Method to Open Modal for Confirmation
   * Declare switch functionality
   */
  function OpenModal(rowIsBlocked, rowId, rowName) {
    setData({
      Id: rowId,
      active: rowIsBlocked,
      Name: rowName,
    });
  }

  const navigate = useNavigate();
  const { currentUserData, logout } = useAuth();

  useEffect(() => {
    if (currentUserData && currentUserData.role === "user") {
      (async () => {
        await logout();
        navigate("/admin/login");
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [filteredDataLength, setFilteredDataLength] = useState(0);

  return (
    <>
      <Toast
        variation={toastMessage.variation}
        title={toastMessage.title}
        open={isToastOpen}
        onOpenChange={toggleToast}
      />
      <AppContainer maxWidth="xl">
        <StyledTable
          TableTitle="Usuarios"
          Component={<ShowTotal total={filteredDataLength} />}
          Labels={
            <Labels
              setModalFilter={setModalFilter}
              orderFilter={orderFilter}
              setOrderFilter={setOrderFilter}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
            />
          }
          TableData={
            <TableData
              modalFilter={modalFilter}
              setModalFilter={setModalFilter}
              dateFilter={dateFilter}
              orderFilter={orderFilter}
              OpenModal={OpenModal}
              OpenDetails={OpenDetails}
              setFilteredDataLength={setFilteredDataLength}
            />
          }
        />
        {details && <Details CloseDetails={CloseDetails} detailsID={Id} />}
        {data && (
          <DialogModal>
            <BlockModal
              onToastOpen={onToastOpen}
              data={data}
              setModal={setData}
              UpdateRow={UpdateRow}
              role="Usuario"
              collection={TABLES.USERS}
            />
          </DialogModal>
        )}
      </AppContainer>
    </>
  );
}
